document.addEventListener('DOMContentLoaded', function() {
  const devSlide = document.querySelector('.is-active.is-current[aria-label="Slide 1"]');
  const buttonToDisableClass = '.oke-reviewCarousel-prev';


  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        const buttonToDisable = document.querySelector(buttonToDisableClass);

        if (buttonToDisable && devSlide) {
          console.log('Button found and disabled');
          buttonToDisable.disabled = true;
          observer.disconnect();
        }
      }
    });
  });

  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  observer.observe(targetNode, config);

 
const discountItems = document.querySelectorAll('.discount_item');

// Store original prices
let originalPrices = {
    onetimeprice: parseFloat($('.one-time-text .c_subs_price').text().replace('$', '').trim()),
    prod_off_orgprice: parseFloat($(".Subscription-off").find("del").text().replace('$', '').trim()),
    prod_off_price: parseFloat($(".Subscription-off").find(".c_subs_price").text().replace('$', '').trim())
};

function checkactivelabel() {
    let subscriptionContainsRemovebg = $('.subscription-order.checkbox-container').hasClass('removebg');
    let onetimeContainsRemovebg = $('.one-time-order.checkbox-container').hasClass('removebg');

    if (subscriptionContainsRemovebg) {
        return originalPrices.prod_off_price;
    } else if (onetimeContainsRemovebg) {
        return originalPrices.onetimeprice;
    }
}

discountItems.forEach(function(item) {
    item.addEventListener('click', function() {
        const isActive = this.classList.contains('active');
        discountItems.forEach(function(discountItem) {
            discountItem.classList.remove('active');
        });
        const revert_initial = document.querySelector('.devOriginalPriceRevert');
        const total_orignal_pricing = document.querySelector('.devCrossOutPrice');
        const discountValue = parseFloat(this.querySelector('.descount_item_info').getAttribute('data-discount'));
        const percentageOff = parseFloat(this.querySelector('.descount_item_info').getAttribute('data-percentage'))/ 100;
        const inputElement = this.closest('.product__meta-inner').querySelector('.devFeatureFormInner .product-form__quantity input');
        const variantId = this.querySelector('.descount_item_info').getAttribute("data-variant");
        
        if (!isActive) {
            // Update prices
            // $('.one-time-text .c_subs_price').text('$' + (originalPrices.onetimeprice * discountValue).toFixed(2));
            // $(".Subscription-off del").text('$' + (originalPrices.prod_off_orgprice * discountValue).toFixed(2));
            // $(".Subscription-off .c_subs_price").text('$' + (originalPrices.prod_off_price * discountValue).toFixed(2));
                     total_orignal_pricing.style.display='block';
                     $(total_orignal_pricing).text('$' + (originalPrices.onetimeprice * discountValue).toFixed(2));
                    // Calculate discounted prices after applying discount amount
                      const onetimePriceAfterDiscount = originalPrices.onetimeprice * discountValue;
                      const prodOffOrgPriceAfterDiscount = originalPrices.prod_off_orgprice * discountValue;
                      const prodOffPriceAfterDiscount = originalPrices.prod_off_price * discountValue;
                  
                      // Apply percentage off to the discounted prices
                      const finalOnetimePrice = onetimePriceAfterDiscount * (1 - percentageOff);
                      const finalProdOffOrgPrice = prodOffOrgPriceAfterDiscount * (1 - percentageOff);
                      const finalProdOffPrice = prodOffPriceAfterDiscount * (1 - percentageOff);
                  
                      // Update the text with the final prices
                      $('.one-time-text .c_subs_price').text('$' + finalOnetimePrice.toFixed(2));
                      $(".Subscription-off del").text('$' + (originalPrices.prod_off_price * discountValue).toFixed(2))
                      $(".Subscription-off .c_subs_price").text('$' + finalProdOffPrice.toFixed(2));
                      
                      console.log(originalPrices.onetimeprice, discountValue, percentageOff);

                        revert_initial.addEventListener('click' ,function(){
                            total_orignal_pricing.style.display='none';
                           $(".Subscription-off del").text('$' + (originalPrices.prod_off_orgprice).toFixed(2));
                          })          
            // Update input value
            inputElement.value = discountValue;
            this.classList.add('active');

             // Reset .c_new_btn_class button .c_subs_btn_price
            const originalBtnPrice = checkactivelabel();
            const total_Price = originalBtnPrice * discountValue;
            const totalDiscountPrice = total_Price * (1 - percentageOff);
            $(".c_new_btn_class button .c_subs_btn_price").text(" - $" + totalDiscountPrice.toFixed(2)  );
              console.log(originalBtnPrice);
            console.log(inputElement.value);
         
        } else {
            // Restore original prices
          console.log('sahdjsk');
            $('.one-time-text .c_subs_price').text('$' + originalPrices.onetimeprice.toFixed(2));
            total_orignal_pricing.style.display='none';
          
            $(".Subscription-off del").text('$' + originalPrices.prod_off_orgprice.toFixed(2));
            $(".Subscription-off .c_subs_price").text('$' + originalPrices.prod_off_price.toFixed(2));
            
            // Reset input value to 1
            inputElement.value = '1';

            // Reset .c_new_btn_class button .c_subs_btn_price
            const originalBtnPrice = checkactivelabel();
            
            $(".c_new_btn_class button .c_subs_btn_price").text(" - $" + originalBtnPrice.toFixed(2));

            console.log(inputElement.value);
        }
         //Update variant ID
         $("button.add-cstm-bt").attr('var_id', variantId);

    });
});
  if (discountItems.length > 0) {
    discountItems[0].classList.add('active');
}
// Select the radio buttons
const subscriptionRadio = document.querySelector('.subscription-order.checkbox-container input[type="radio"]');
const oneTimeRadio = document.querySelector('.one-time-order.checkbox-container input[type="radio"]');

// Listen for change event on subscription radio button
if(subscriptionRadio){subscriptionRadio.addEventListener('change', updateDescription);}

// Listen for change event on one-time radio button
if(oneTimeRadio){oneTimeRadio.addEventListener('change', updateDescription);}

// Function to update description based on selected radio button
function updateDescription() {
    const descriptionElement = discountItems[0].querySelector('.desc_discount'); // Target the description element within discountItems[0]

    if (subscriptionRadio.checked) {
      if(descriptionElement)
      {
        descriptionElement.style.opacity = '1'; // Show the description if subscription radio button is checked
      }
        
    } else {
       if(descriptionElement)
      {
        descriptionElement.style.opacity = '0'; // Hide the description if one-time radio button is checked
      }
    }
}




  
});


